/**
 * Which account this tab acts as, while there is no portal to sign in to.
 *
 * Development only (see `config.devAccounts`). The name of an account is kept
 * in `localStorage` so a reload stays the same person, and travels in a header
 * the API reads only when it has the same switch on. It is a name, never a
 * token: the tokens stay in a directory on the server's side.
 */

import { config } from '@/app/config'

const KEY = 'dmbuilder.devAccount'

/** The account chosen, or null for the fixed development user. */
export function chosenDevAccount(): string | null {
  if (!config.devAccounts) return null
  try {
    return window.localStorage.getItem(KEY) || null
  } catch {
    return null
  }
}

export function chooseDevAccount(key: string | null): void {
  try {
    if (key) window.localStorage.setItem(KEY, key)
    else window.localStorage.removeItem(KEY)
  } catch {
    // Storage can be unavailable; the switch then simply does not stick.
  }
}
